// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96643630","453":"c28c6666","455":"75d96fe4"}[chunkId] + ".chunk.js";
};